import { gql } from '@apollo/client'
import { CHATBOT_CONVERSATION_FIELDS } from './fragments/chatbot_conversation'

export const DELETE_CHATBOT_CONVERSATION = gql`
  ${CHATBOT_CONVERSATION_FIELDS}
  mutation deleteChatbotConversation($id: ID!) {
    deleteChatbotConversation(id: $id) {
      ...ChatbotConversationFields
    }
  }
`
